import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled(Box)`
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--Mobile-border-primary, #dfe4e8);
`;

export const AlertsDetailRow = styled(Box)<{ $isLast?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding-bottom: 8px;
  align-self: stretch;
  ${({ $isLast }) => ($isLast ? '' : 'border-bottom: 1px solid var(--Mobile-border-primary, #DFE4E8);')}
`;
